export default __webpack_public_path__ + "static/media/023-pepper.76e68d97.svg";